import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function Cart() {
  const { cart, removeFromCart, updateQty, clearCart } = useCart();
  const navigate = useNavigate();

  const subtotal = cart.reduce(
    (sum, item) => sum + item.price * item.qty,
    0
  );

  if (cart.length === 0) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center text-gray-500">
        <p className="mb-3">Your cart is empty.</p>
        <Link
          to="/products"
          className="px-4 py-2 bg-black text-white rounded-full text-sm"
        >
          Browse products
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Your Cart</h1>

      <div className="bg-white rounded-xl shadow p-4 mb-4">
        {cart.map((item) => (
          <div
            key={item.key}
            className="flex items-center gap-4 border-b last:border-b-0 py-3"
          >
            <img
              src={item.images?.[0]}
              alt={item.name}
              className="w-16 h-16 rounded object-cover bg-gray-100"
            />

            <div className="flex-1">
              <div className="font-semibold">{item.name}</div>
              {item.variantName && (
                <div className="text-xs text-gray-500">
                  Option: {item.variantName}
                </div>
              )}
              {item.sku && (
                <div className="text-[11px] text-gray-400">SKU: {item.sku}</div>
              )}
              <div className="text-sm text-gray-600 mt-1">
                Unit: ${item.price.toLocaleString()}
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={() => updateQty(item.key, item.qty - 1)}
                className="w-7 h-7 rounded-full border flex items-center justify-center"
              >
                -
              </button>
              <span className="w-8 text-center">{item.qty}</span>
              <button
                onClick={() => updateQty(item.key, item.qty + 1)}
                className="w-7 h-7 rounded-full border flex items-center justify-center"
              >
                +
              </button>
            </div>

            <div className="w-20 text-right font-semibold">
              ${(item.price * item.qty).toLocaleString()}
            </div>

            <button
              onClick={() => removeFromCart(item.key)}
              className="text-xs text-red-500 hover:underline ml-2"
            >
              Remove
            </button>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between mt-4">
        <button
          onClick={clearCart}
          className="text-sm text-gray-500 hover:underline"
        >
          Clear cart
        </button>

        <div className="text-right">
          <div className="text-sm text-gray-500">Subtotal</div>
          <div className="text-2xl font-bold">
            ${subtotal.toLocaleString()}
          </div>
          <button
            onClick={() => navigate("/checkout")}
            className="mt-3 px-5 py-2 bg-black text-white rounded-full text-sm hover:bg-gray-800"
          >
            Checkout
          </button>
        </div>
      </div>
    </div>
  );
}
